import React from "react";
import PropTypes from "prop-types";
import { buildScopeTranslate } from "lib/I18n";

const DEFAULT_SCOPE = "views.content.agentforce.assessments.common";

const LoadingScreen = ({ scope = DEFAULT_SCOPE, testId = "loading-screen" }) => {
  const tCommon = buildScopeTranslate(scope);

  return (
    <div
      className="slds-align_absolute-center slds-grid slds-grid_vertical slds-grid_align-center slds-p-around_xx-large th-agentforce-assessment__loading"
      role="status"
      data-testid={testId}>
      <h1 className="th-sr-only">{tCommon("loading")}</h1>
      <tds-spinner size="medium" data-testid="loading-spinner" aria-hidden="true"></tds-spinner>
      <p className="slds-text-heading_medium slds-m-top_medium" data-testid="loading-text">{tCommon("loading")}</p>
    </div>
  );
};

LoadingScreen.propTypes = {
  // i18n scope for the loading copy. Override to reuse this screen outside the
  // agentforce assessment (e.g. the modular assessment framework).
  scope: PropTypes.string,
  // Container data-testid; override when the host UI needs its own selector.
  testId: PropTypes.string,
};

export default LoadingScreen;
